export default "__VITE_ASSET__DmbNd0wO__"